import { createStructuredSelector } from 'reselect'

import {
  REQUEST_DETAIL_GREEN_CERTIFICATE_LIST,
  REQUEST_DETAIL_GREEN_CERTIFICATE_LIST_SUCCESS,
  REQUEST_DETAIL_GREEN_CERTIFICATE_LIST_ERROR,
  REQUEST_DETAIL_GREEN_CERTIFICATE_PAGE_SET,
  REQUEST_DETAIL_GREEN_CERTIFICATE_SEARCH_SET,
  REQUEST_DETAIL_GREEN_CERTIFICATE_SEARCH_CHANGE,
  REQUEST_DETAIL_GREEN_CERTIFICATE_SEARCH_GEO_COUNTRY_LIST,
  REQUEST_DETAIL_GREEN_CERTIFICATE_SEARCH_GEO_COUNTRY_LIST_SUCCESS,
  REQUEST_DETAIL_GREEN_CERTIFICATE_SEARCH_GEO_COUNTRY_LIST_ERROR,
  REQUEST_DETAIL_GREEN_CERTIFICATE_SEARCH_HEALTH_AGENCY_LIST,
  REQUEST_DETAIL_GREEN_CERTIFICATE_SEARCH_HEALTH_AGENCY_LIST_SUCCESS,
  REQUEST_DETAIL_GREEN_CERTIFICATE_SEARCH_HEALTH_AGENCY_LIST_ERROR,
  REQUEST_DETAIL_GREEN_CERTIFICATE_ADD_SET,
  REQUEST_DETAIL_GREEN_CERTIFICATE_ADD_MODAL_SET,
  REQUEST_DETAIL_GREEN_CERTIFICATE_ADD,
  REQUEST_DETAIL_GREEN_CERTIFICATE_ADD_SUCCESS,
  REQUEST_DETAIL_GREEN_CERTIFICATE_ADD_ERROR,
  REQUEST_DETAIL_GREEN_CERTIFICATE_ADD_CHANGE,
  REQUEST_DETAIL_GREEN_CERTIFICATE_DETAIL,
  REQUEST_DETAIL_GREEN_CERTIFICATE_DETAIL_SUCCESS,
  REQUEST_DETAIL_GREEN_CERTIFICATE_DETAIL_ERROR,
  REQUEST_DETAIL_GREEN_CERTIFICATE_VIEW_MODAL_SET,
  REQUEST_DETAIL_GREEN_CERTIFICATE_EDIT_CHANGE,
  REQUEST_DETAIL_GREEN_CERTIFICATE_EDIT_MODAL_SET,
  REQUEST_DETAIL_GREEN_CERTIFICATE_UPDATE,
  REQUEST_DETAIL_GREEN_CERTIFICATE_UPDATE_SUCCESS,
  REQUEST_DETAIL_GREEN_CERTIFICATE_UPDATE_ERROR,
  REQUEST_DETAIL_GREEN_CERTIFICATE_VIEW_TAB_SET
} from '../actions';

export const NAME = 'request_detail_green_certificate';

export const RequestDetailGreenCertificateList = (page, num_page, orderBy, filters, stateFilter, display) => ({
  type: REQUEST_DETAIL_GREEN_CERTIFICATE_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter, display: display }
});

export const RequestDetailGreenCertificateListSuccess = (data) => ({
  type: REQUEST_DETAIL_GREEN_CERTIFICATE_LIST_SUCCESS,
  payload: data
});

export const RequestDetailGreenCertificateListError = (error) => ({
  type: REQUEST_DETAIL_GREEN_CERTIFICATE_LIST_ERROR,
  payload: error
});

export const RequestDetailGreenCertificatePageSet = (data) => ({
  type: REQUEST_DETAIL_GREEN_CERTIFICATE_PAGE_SET,
  payload: data
});

export const RequestDetailGreenCertificateSearchSet = (data) => ({
  type: REQUEST_DETAIL_GREEN_CERTIFICATE_SEARCH_SET,
  payload: data
});

export const RequestDetailGreenCertificateSearchChangeSet = (data) => ({
  type: REQUEST_DETAIL_GREEN_CERTIFICATE_SEARCH_CHANGE,
  payload: data
});

export const RequestDetailGreenCertificateSearchGeoCountryList = (data) => ({
  type: REQUEST_DETAIL_GREEN_CERTIFICATE_SEARCH_GEO_COUNTRY_LIST,
  payload: data
});

export const RequestDetailGreenCertificateSearchGeoCountryListSuccess = (message) => ({
  type: REQUEST_DETAIL_GREEN_CERTIFICATE_SEARCH_GEO_COUNTRY_LIST_SUCCESS,
  payload: message
});

export const RequestDetailGreenCertificateSearchGeoCountryListError = (error) => ({
  type: REQUEST_DETAIL_GREEN_CERTIFICATE_SEARCH_GEO_COUNTRY_LIST_ERROR,
  payload: error
});

export const RequestDetailGreenCertificateSearchHealthAgencyList = (data) => ({
  type: REQUEST_DETAIL_GREEN_CERTIFICATE_SEARCH_HEALTH_AGENCY_LIST,
  payload: data
});

export const RequestDetailGreenCertificateSearchHealthAgencyListSuccess = (message) => ({
  type: REQUEST_DETAIL_GREEN_CERTIFICATE_SEARCH_HEALTH_AGENCY_LIST_SUCCESS,
  payload: message
});

export const RequestDetailGreenCertificateSearchHealthAgencyListError = (error) => ({
  type: REQUEST_DETAIL_GREEN_CERTIFICATE_SEARCH_HEALTH_AGENCY_LIST_ERROR,
  payload: error
});

export const RequestDetailGreenCertificateAddChangeSet = (data) => ({
  type: REQUEST_DETAIL_GREEN_CERTIFICATE_ADD_CHANGE,
  payload: data
});

export const RequestDetailGreenCertificateAddSet = (data) => ({
  type: REQUEST_DETAIL_GREEN_CERTIFICATE_ADD_SET,
  payload: data
});

export const RequestDetailGreenCertificateAddModalSet = (data) => ({
  type: REQUEST_DETAIL_GREEN_CERTIFICATE_ADD_MODAL_SET,
  payload: data
});

export const RequestDetailGreenCertificateAdd = (data) => ({
  type: REQUEST_DETAIL_GREEN_CERTIFICATE_ADD,
  payload: data
});

export const RequestDetailGreenCertificateAddSuccess = (message) => ({
  type: REQUEST_DETAIL_GREEN_CERTIFICATE_ADD_SUCCESS,
  payload: message
});

export const RequestDetailGreenCertificateAddError = (error) => ({
  type: REQUEST_DETAIL_GREEN_CERTIFICATE_ADD_ERROR,
  payload: error
});

export const RequestDetailGreenCertificateDetail = (data) => ({
  type: REQUEST_DETAIL_GREEN_CERTIFICATE_DETAIL,
  payload: data
});

export const RequestDetailGreenCertificateDetailSuccess = (data) => ({
  type: REQUEST_DETAIL_GREEN_CERTIFICATE_DETAIL_SUCCESS,
  payload: data
});

export const RequestDetailGreenCertificateDetailError = (error) => ({
  type: REQUEST_DETAIL_GREEN_CERTIFICATE_DETAIL_ERROR,
  payload: error
});

export const RequestDetailGreenCertificateViewModalSet = (data) => ({
  type: REQUEST_DETAIL_GREEN_CERTIFICATE_VIEW_MODAL_SET,
  payload: data
});

export const RequestDetailGreenCertificateEditModalSet = (data) => ({
  type: REQUEST_DETAIL_GREEN_CERTIFICATE_EDIT_MODAL_SET,
  payload: data
});

export const RequestDetailGreenCertificateEditChangeSet = (data) => ({
  type: REQUEST_DETAIL_GREEN_CERTIFICATE_EDIT_CHANGE,
  payload: data
});

export const RequestDetailGreenCertificateUpdate = (data) => ({
  type: REQUEST_DETAIL_GREEN_CERTIFICATE_UPDATE,
  payload: data
});

export const RequestDetailGreenCertificateUpdateSuccess = (message) => ({
  type: REQUEST_DETAIL_GREEN_CERTIFICATE_UPDATE_SUCCESS,
  payload: message.message
});

export const RequestDetailGreenCertificateUpdateError = (error) => ({
  type: REQUEST_DETAIL_GREEN_CERTIFICATE_UPDATE_ERROR,
  payload: error
});

export const RequestDetailGreenCertificateViewTabSet = (data) => ({
  type: REQUEST_DETAIL_GREEN_CERTIFICATE_VIEW_TAB_SET,
  payload: data
});

const request_detail_green_certificate = (state) => state[NAME];

export const RequestDetailGreenCertificateSelector = createStructuredSelector({
  request_detail_green_certificate
})
